import React, { useEffect } from 'react'
import styled from 'styled-components'

import CenteredLoader from 'components/lib/CenteredLoader'
import Button from 'components/lib/DesignSystem/Button'
import Modal from 'components/lib/DesignSystem/Modal'

const ValidToFreeTrailSection = ({ atLeastCorePlan }) => (
  <>
    <p>
      Your plan will immediately upgrade to a free
      <b> 14 day no-commitment </b>
      Complete Protect trial.
    </p>
    {atLeastCorePlan ? (
      <>
        <p>
          The trial will activate Account Takeover (ATO) protection and give you access to
          IRONSCALES' Security Awareness Training.
        </p>
        <p>
          An IRONSCALES representative will contact you within 5 business days to go over the
          configurations and activate Teams Protection if you choose so.
        </p>
      </>
    ) : (
      <>
        <p>
          The trial will start in Silent Mode, not affecting the mailboxes. However, IRONSCALES will
          auto-detect malicious emails and create incidents.
        </p>
        <p>
          An IRONSCALES representative will contact you within 5 business days to go over the
          configurations and disable Silent Mode if you choose so.
        </p>
      </>
    )}
  </>
)

const NotValidToFreeTrialSection = () => (
  <p>An IRONSCALES representative will contact you within 5 business days to discuss next steps.</p>
)

function FreeTrialModal({
  onClose,
  className,
  isLoading,
  isValid,
  error,
  success,
  onSubmit,
  atLeastCorePlan,
}) {
  useEffect(() => {
    if (success) onClose()
  }, [success, onClose])

  return (
    <Modal
      width="818px"
      onClose={onClose}
      title="Confirm Interest"
      open
      modalType={error && 'error'}
      footer={
        !error &&
        !isLoading && (
          <div>
            <Button
              id="Upgrade_Modal_Free_Trial_Cancel"
              styleType="tertiary"
              text="No, Thanks"
              className="mr"
              onClick={onClose}
            />
            {isValid && (
              <Button
                id="Upgrade_Modal_Contact_Me_Submit"
                styleType="secondary"
                disabled={isLoading}
                text="Contact Me"
                className="mr"
                onClick={() => onSubmit(true)}
              />
            )}
            <Button
              id="Upgrade_Modal_Free_Trial_Submit"
              disabled={isLoading}
              text={isValid ? 'Start free trial now' : 'Contact Me'}
              onClick={() => onSubmit(false)}
            />
          </div>
        )
      }
    >
      <div className={className}>
        <div className="content">
          <img src="/static/webapp/images/spaceship.png" />
          <section>
            {isLoading ? (
              <CenteredLoader />
            ) : (
              <>
                {!error ? (
                  isValid ? (
                    <ValidToFreeTrailSection atLeastCorePlan={atLeastCorePlan} />
                  ) : (
                    <NotValidToFreeTrialSection />
                  )
                ) : null}
                {error && <p className="error">{error.detail}</p>}
              </>
            )}
          </section>
        </div>
      </div>
    </Modal>
  )
}

export default styled(FreeTrialModal)`
  padding: 30px;
  img {
    width: 215px;
    height: 215px;
  }
  .content {
    margin-bottom: 40px;
    display: flex;
    gap: 40px;
    section {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 32px;
      align-items: center;
      justify-content: center;
      p {
        font-weight: 400;
        margin: 0;
        &.error {
          color: ${({ theme }) => theme.red};
          font-weight: 600;
        }
      }
    }
  }
`
